import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import type { Profile, ProfileBody } from '../types/profile.types';

export const fetchProfile = async (): Promise<Profile> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.profile}`);
};

/** Replaces the personal data and the children; the phone number changes through updatePhone. */
export const updateProfile = async (body: ProfileBody): Promise<Profile> => {
  return await request.put(`${URLS.BACK_DSH}${APIS.profile}`, body);
};

/** Makes the number verified with a change_phone code (in this browser session) the account's. */
export const updatePhone = async (): Promise<Profile> => {
  return await request.put(`${URLS.BACK_DSH}${APIS.profilePhone}`);
};
